import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { RateLineApprovalQueuePage } from './features/approvals/pages/RateLineApprovalQueuePage';
import { OffcardReportPage } from './features/offcard-report/pages/OffcardReportPage';
import { ImportRateLinesPage } from './features/import-export/pages/ImportRateLinesPage';
import { RateCardDetailPage } from './pages/RateCardDetailPage';
import { RateCardsPage } from './pages/RateCardsPage';
import { RATE_CARD_TABS } from './rate-cards.paths';

/** The rate card screens, for the router to place inside the office shell. */
export const RATE_CARD_ROUTES: RouteObject[] = [
  { path: 'rate-cards', element: <RateCardsPage /> },
  { path: 'rate-cards/approvals', element: <RateLineApprovalQueuePage /> },
  { path: 'rate-cards/off-card-report', element: <OffcardReportPage /> },
  { path: 'rate-cards/:id/lines/import', element: <ImportRateLinesPage /> },
  ...recordTabRoutes('rate-cards/:id', RATE_CARD_TABS, (tab) => <RateCardDetailPage tab={tab} />),
];
